import React from 'react';
import { useLocation } from "react-router-dom";

import { Box, Button } from '@mui/material';

import { Menu } from '../components/Menu'
import { checkRole } from '../scripts/utils'

import Users from '../components/configs/Users'
import BillingItems from '../components/configs/BillingItems';
import TypeOfGoods from '../components/configs/TypeOfGoods';

import { useData } from '../hooks/DataProvider';

import translations from '../scripts/translations.json';


function ConfigMenu({ _type, setType }) {

    const { language } = useData();

    const btns = translations.button[language];


    const Btns = [
        { id: 'users', icon: '', roles: ['admin'] },
        { id: 'billingItems', icon: '', roles: ['admin'] },
        { id: 'typeOfGoods', icon: '', roles: ['admin'] },
    ]

    const role = localStorage.getItem('role')
    const filteredBtns = Btns.filter(item => item.roles.includes(role))

    return (
        <Box sx={{ mb: 2 }}>
            {filteredBtns.map(item => {
                return (
                    <Button
                        key={item.id}
                        size='small'
                        variant='outlined'
                        onClick={() => { setType(item.id); console.log(item.id) }}
                        disabled={item.id === _type ? true : false}
                        sx={{ mr: 1, mb: 1, }}
                    >
                        {btns[item.id]}
                    </Button>)
            }
            )}
        </Box>
    )
}


const Settings = () => {

    const location = useLocation();
    checkRole(location.pathname)

    const [type, setType] = React.useState('typeOfGoods')

    const module = () => {
        switch (type) {
            case 'users':
                return <Users />
            case 'billingItems':
                return <BillingItems />
            case 'typeOfGoods':
                return <TypeOfGoods />
            default:
                return <TypeOfGoods />
        }
    }

    return (
        <>
            <Menu />
            <Box>

                <ConfigMenu _type={type} setType={setType} />
                {module()}

            </Box>
        </>
    );
}

export default Settings;
